import { combineReducers } from 'redux';
import reduceErrors from './errors';
import reduceConfig from './config';
import reduceUi from './ui';
import reduceQuery from './query';
import reduceLive from './live';
import reduceHistory from './history'
import reduceWordpress from './wordpress'
import reduceRoutes from './routes.js'


export default combineReducers({
	live: reduceLive,
	query: reduceQuery,
	config: reduceConfig,
	errors: reduceErrors,
	ui: reduceUi,
	history: reduceHistory,
	wordpress: reduceWordpress,
	routes: reduceRoutes,
});